import React, {useState} from "react";
import {Box, Button, Tab, Tabs, Typography} from "@mui/material";
import UserData from "./components/UserData";
import PasswordSecurity from "./components/PasswordSecurity";
import MainCard from "../../components/common/MainCard";
import {CenteredHeader, UserSettingsWrapper} from "./UserSettings.styled";
import {useTranslation} from 'react-i18next';
import {useUser} from "../../contexts/UserContext";
import {env} from "../../config/environment";

const UserSettings = () => {
    const {t} = useTranslation();
    const [activeTab, setActiveTab] = useState(0);

    const {user} = useUser();

    const hasExternalAccountResetPasswordUrl = env.hasExternalPasswordReset ? env.passwordResetUrl : null;

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    const redirectToExternalPasswordReset = () => {
        window.open(env.passwordResetUrl, '_blank', 'noopener,noreferrer');
    };

    return (
        <UserSettingsWrapper role="region" aria-labelledby="user-settings-title">
            <MainCard width="100%" height="auto">
                <CenteredHeader>
                    <h2 id="user-settings-title">{t('userSettings.title')}</h2>
                </CenteredHeader>

                <Box sx={{borderBottom: 'none !important'}}>
                    <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        aria-label={t('userSettings.tabs.ariaLabel') as string}
                    >
                        <Tab id="user-data-tab" aria-controls="user-data-panel" label={t('userSettings.userData')} sx={{textTransform: 'none'}}/>
                        <Tab id="password-security-tab" aria-controls="password-security-panel" label={t('userSettings.passwordSecurity')} sx={{textTransform: 'none'}}/>
                    </Tabs>
                </Box>

                {activeTab === 0 && (
                    <Box role="tabpanel" id="user-data-panel" aria-labelledby="user-data-tab" aria-label={t('userSettings.panel.userData.ariaLabel') as string}>
                        <UserData />
                    </Box>
                )}
                {(activeTab === 1) && (
                    <Box role="tabpanel" id="password-security-panel" aria-labelledby="password-security-tab" aria-label={t('userSettings.panel.passwordSecurity.ariaLabel') as string}>
                        {user?.isAdUser
                            ? (
                                <>
                                    <Typography variant="body1" component="p" sx={{mt: 4, mb: 4}}>
                                        {t('userSettings.externalAccountInfo')}
                                    </Typography>
                                    {hasExternalAccountResetPasswordUrl && (
                                        <Button variant="outlined" onClick={redirectToExternalPasswordReset}>
                                            {t('userSettings.resetBtn')}
                                        </Button>
                                    )}
                                </>
                            )
                            : (<PasswordSecurity />)
                        }
                    </Box>
                )}
            </MainCard>
        </UserSettingsWrapper>
    );
};

export default UserSettings;
